import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScorecardDisplayType, ScorecardQuery, ScorecardService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ScorecardDisplayTypesModule } from '@fgb/portal-component-library/src/lib/loyalty/scorecards/scorecard-display-types';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ngx-owl-carousel-o';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/loyalty/scorecards/scorecard-display-types';
import * as ɵngcc6 from '@ngx-translate/core';

const _c0 = function () { return ["/badges"]; };
function ScorecardCarouselComponent_ng_container_0_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "span", 10);
    ɵngcc0.ɵɵtext(2, "Show All");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 11);
    ɵngcc0.ɵɵtext(4, "arrow_forward_ios");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(1, _c0));
} }
function ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_ng_template_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "fgbcl-scorecard-punchcard-view", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const scorecard_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("scorecard", scorecard_r5);
} }
function ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_ng_template_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "fgbcl-scorecard-number-view", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const scorecard_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("scorecard", scorecard_r5);
} }
function ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_ng_template_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "fgbcl-scorecard-progress-bar-view", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const scorecard_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("scorecard", scorecard_r5);
} }
function ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_ng_template_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "fgbcl-scorecard-milestone-progress-bar-view", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const scorecard_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("scorecard", scorecard_r5);
} }
function ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementContainerStart(1, 13);
    ɵngcc0.ɵɵtemplate(2, ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_ng_template_1_ng_container_2_Template, 2, 1, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(3, ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_ng_template_1_ng_container_3_Template, 2, 1, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(4, ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_ng_template_1_ng_container_4_Template, 2, 1, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(5, ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_ng_template_1_ng_container_5_Template, 2, 1, "ng-container", 14);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const scorecard_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("ngSwitch", scorecard_r5.ScoreCardDisplayType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r6.scorecardDisplayType.punchcardView);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r6.scorecardDisplayType.numberView);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r6.scorecardDisplayType.progressBarView);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r6.scorecardDisplayType.milestoneProgressBarView);
} }
function ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_ng_template_1_Template, 6, 5, "ng-template", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function ScorecardCarouselComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "h2", 5);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, ScorecardCarouselComponent_ng_container_0_div_1_div_6_Template, 5, 2, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "owl-carousel-o", 7);
    ɵngcc0.ɵɵtemplate(8, ScorecardCarouselComponent_ng_container_0_div_1_ng_container_8_Template, 2, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const activeScorecards_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 4, "badge.featured.challenges"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showAllView);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("options", ctx_r2.customOptions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", activeScorecards_r1);
} }
function ScorecardCarouselComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ScorecardCarouselComponent_ng_container_0_div_1_Template, 9, 6, "div", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const activeScorecards_r1 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", activeScorecards_r1.length > 0);
} }
class ScorecardCarouselComponent {
    constructor(scorecardQuery, scorecardService) {
        this.scorecardQuery = scorecardQuery;
        this.scorecardService = scorecardService;
        this.scorecardDisplayType = ScorecardDisplayType;
        this.customOptions = {
            margin: 8,
            autoWidth: true,
            pullDrag: true,
            autoplay: false,
            autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
            autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
            navSpeed: 700,
            nav: false,
            responsive: {
                0: { items: 1.02 },
                900: { items: 3.02 },
            },
        };
    }
    ngOnInit() {
        this.scorecardService.fetchScorecards().toPromise();
        this.scorecard$ = this.scorecardQuery.selectAll();
    }
}
ScorecardCarouselComponent.ɵfac = function ScorecardCarouselComponent_Factory(t) { return new (t || ScorecardCarouselComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ScorecardQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ScorecardService)); };
ScorecardCarouselComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ScorecardCarouselComponent, selectors: [["fgbcl-scorecard-carousel"]], inputs: { showAllView: "showAllView" }, decls: 2, vars: 3, consts: [[4, "ngIf"], ["class", "bg-carousel", 4, "ngIf"], [1, "bg-carousel"], [1, "container", "py-4"], [1, "d-flex", "justify-content-between", "text-white", "mb-2"], [1, "badge-carousel-subheading", "my-0"], ["class", "d-flex align-items-center cursor-pointer", 3, "routerLink", 4, "ngIf"], [3, "options"], [4, "ngFor", "ngForOf"], [1, "d-flex", "align-items-center", "cursor-pointer", 3, "routerLink"], [1, "font-size-14"], ["aria-hidden", "true", 1, "icon", "material-icons", "pl-1", "font-size-14", "font-weight-bold"], ["carouselSlide", ""], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "scorecard"]], template: function ScorecardCarouselComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ScorecardCarouselComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.scorecard$));
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.CarouselComponent, ɵngcc2.NgForOf, ɵngcc4.RouterLink, ɵngcc3.CarouselSlideDirective, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc5.ScorecardPunchcardViewComponent, ɵngcc5.ScorecardNumberViewComponent, ɵngcc5.ScorecardProgressBarViewComponent, ɵngcc5.ScorecardMilestoneProgressBarViewComponent], pipes: [ɵngcc2.AsyncPipe, ɵngcc6.TranslatePipe], styles: [".bg-carousel[_ngcontent-%COMP%]{height:315px;background-color:#212529}"] });
ScorecardCarouselComponent.ctorParameters = () => [
    { type: ScorecardQuery },
    { type: ScorecardService }
];
ScorecardCarouselComponent.propDecorators = {
    showAllView: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScorecardCarouselComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-scorecard-carousel',
                template: "<ng-container *ngIf=\"scorecard$ | async as activeScorecards\">\r\n  <div class=\"bg-carousel\" *ngIf=\"activeScorecards.length > 0\">\r\n    <div class=\"container py-4\">\r\n      <div class=\"d-flex justify-content-between text-white mb-2\">\r\n        <h2 class=\"badge-carousel-subheading my-0\">{{ 'badge.featured.challenges' | translate }}</h2>\r\n        <div class=\"d-flex align-items-center cursor-pointer\" *ngIf=\"showAllView\" [routerLink]=\"['/badges']\">\r\n          <span class=\"font-size-14\">Show All</span>\r\n          <span class=\"icon material-icons pl-1 font-size-14 font-weight-bold\" aria-hidden=\"true\">arrow_forward_ios</span>\r\n        </div>\r\n      </div>\r\n      <owl-carousel-o [options]=\"customOptions\">\r\n        <ng-container *ngFor=\"let scorecard of activeScorecards\">\r\n          <ng-template carouselSlide>\r\n            <div>\r\n              <ng-container ngSwitch=\"{{ scorecard.ScoreCardDisplayType }}\">\r\n                <ng-container *ngSwitchCase=\"scorecardDisplayType.punchcardView\">\r\n                  <fgbcl-scorecard-punchcard-view [scorecard]=\"scorecard\"></fgbcl-scorecard-punchcard-view>\r\n                </ng-container>\r\n                <ng-container *ngSwitchCase=\"scorecardDisplayType.numberView\">\r\n                  <fgbcl-scorecard-number-view [scorecard]=\"scorecard\"></fgbcl-scorecard-number-view>\r\n                </ng-container>\r\n                <ng-container *ngSwitchCase=\"scorecardDisplayType.progressBarView\">\r\n                  <fgbcl-scorecard-progress-bar-view [scorecard]=\"scorecard\"></fgbcl-scorecard-progress-bar-view>\r\n                </ng-container>\r\n                <ng-container *ngSwitchCase=\"scorecardDisplayType.milestoneProgressBarView\">\r\n                  <fgbcl-scorecard-milestone-progress-bar-view\r\n                    [scorecard]=\"scorecard\"\r\n                  ></fgbcl-scorecard-milestone-progress-bar-view>\r\n                </ng-container>\r\n              </ng-container>\r\n            </div>\r\n          </ng-template>\r\n        </ng-container>\r\n      </owl-carousel-o>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n",
                styles: [".bg-carousel{height:315px;background-color:#212529}"]
            }]
    }], function () { return [{ type: ɵngcc1.ScorecardQuery }, { type: ɵngcc1.ScorecardService }]; }, { showAllView: [{
            type: Input
        }] }); })();

class ScorecardCarouselModule {
}
ScorecardCarouselModule.ɵfac = function ScorecardCarouselModule_Factory(t) { return new (t || ScorecardCarouselModule)(); };
ScorecardCarouselModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ScorecardCarouselModule });
ScorecardCarouselModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PipesModule,
            RouterModule,
            CarouselModule,
            ScorecardDisplayTypesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ScorecardCarouselModule, { declarations: function () { return [ScorecardCarouselComponent]; }, imports: function () { return [CommonModule,
        PipesModule,
        RouterModule,
        CarouselModule,
        ScorecardDisplayTypesModule, ɵngcc6.TranslateModule]; }, exports: function () { return [ScorecardCarouselComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScorecardCarouselModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ScorecardCarouselComponent,
                ],
                imports: [
                    CommonModule,
                    PipesModule,
                    RouterModule,
                    CarouselModule,
                    ScorecardDisplayTypesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [
                    ScorecardCarouselComponent
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ScorecardCarouselComponent, ScorecardCarouselModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-scorecards-scorecard-carousel.js.map